{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/widget-group",
	"title": "Widget Group",
	"category": "widgets",
	"attributes": {
		"title": {
			"type": "string"
		}
	},
	"supports": {
		"html": false,
		"inserter": true,
		"customClassName": true,
		"reusable": false
	},
	"editorStyle": "wp-block-widget-group-editor",
	"style": "wp-block-widget-group"
}
